import { refinementList } from "instantsearch.js/es/widgets";

const servicesRefinementWidget = (I18n) =>
  refinementList({
    container: "#services-refinement",
    attribute: "services.name",
    operator: "and",
    showMore: true,
    limit: 10,
    cssClasses: {
      root: "text-center mx-auto",
      list: "mb-0 p-0",
      item: "btn btn-sm btn-outline-primary btn-round m-1 px-2 py-1",
      label: "m-auto cursor-pointer",
      selectedItem: "btn-primary text-white dark-active-service-btn",
      showMore: "btn btn-sm btn-primary btn-round m-1",
      count: "badge rounded-pill bg-warning mx-1 text-dark",
      checkbox: "d-none",
    },
    templates: {
      showMoreText: `
        {{#isShowingMore}}
          ${I18n.translate("stimulus.professional_search.show_less")}
        {{/isShowingMore}}
        {{^isShowingMore}}
          ${I18n.translate("stimulus.professional_search.show_more")}
        {{/isShowingMore}}
      `,
    },
  });

export default servicesRefinementWidget;
